import { type SessionDto } from '../api/types'
import { type Session } from '../model/types'

export function mapHistoryLog(dto: SessionDto): Session {
  return dto?.data || []
}
